import { styled } from '@mui/material';
import Image from 'src/components/Image';

export const Photo = styled(Image)({
	maxHeight: '360px',
	objectFit: 'contain',
	cursor: 'pointer',
});
